import { render, staticRenderFns } from "./otherStore.vue?vue&type=template&id=40090482&scoped=true"
import script from "./otherStore.vue?vue&type=script&lang=js"
export * from "./otherStore.vue?vue&type=script&lang=js"
import style0 from "./otherStore.vue?vue&type=style&index=0&id=40090482&prod&lang=scss&scoped=true"
import style1 from "./otherStore.vue?vue&type=style&index=1&id=40090482&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40090482",
  null
  
)

export default component.exports